export default __webpack_public_path__ + "static/media/a011-market-2.4d9b0131.svg";